<template>
<div>
  <div v-if="!isMobile">
    <div
      v-if="subStep == 1"
      class="container-input">
      <div class="input-header">
        <strong>Etapa 1 de {{ nRootSteps }} - Escolha a quantidade de pessoas</strong>
      </div>
      <div class="input-body">
        <div
          v-for="option in options"
          :key="option.id"
          class="faixa-option">
          <div class="faixa-option-info">
            <strong>{{ option.nome }}</strong>
            <br>
            <span>({{ option.descricao }})</span>
            <br>
          </div>
          <div
            class="faixa-option-quantity"
            translate="no">
            <i
              class="fa-solid fa-minus"
              style="cursor: pointer"
              @click="sub(option)" />
            <div class="faixa-option-quantity-display">
              <strong>{{ getCurrentQuantidade(option) }}</strong>
            </div>
            <i
              class="fa-solid fa-plus"
              style="cursor: pointer"
              @click="add(option)" />
          </div>
        </div>
        <div :style="{ visibility: isDependentOnly ? 'visible' : 'hidden' }">
          <small>É necessário adicionar ao menos 1 não dependente</small>
        </div>
        <div
          v-if="minVenda > 1 || maxVenda < Infinity"
          class="compliance-alert">
          <small v-if="minVenda > 1 && maxVenda < Infinity">
            O máximo de vagas para a compra desse combo por pessoa é: {{ maxVenda }} (caso tenha
            disponibilidade). E no mínimo {{ minVenda }}.
          </small>
          <small v-if="minVenda <= 1 && maxVenda < Infinity">
            O máximo de vagas para a compra desse combo por pessoa é: {{ maxVenda }} (caso tenha
            disponibilidade).
          </small>
          <small v-if="minVenda > 1 && maxVenda == Infinity">
            O mínimo de vagas para a compra desse combo por pessoa é: {{ minVenda }} (caso tenha
            disponibilidade).
          </small>
        </div>
      </div>
    </div>

    <div v-show="subStep == 2">
      <div class="input-header">
        <strong>
          Etapa 2 de {{ nRootSteps }} - Escolha a data para as {{ nActivities }} atividades
        </strong>
      </div>
      <input-data-calendario
        v-if="onlySameDate"
        v-model="selectedDate"
        :passeio-id="comboId"
        :is-combo="true"
        :initial-available-days="initialAvailableDays"
        :calendar-size="calendarSizeParsed"
        :start-opened="true"
        @on-open-change="heightChange" />
    </div>
    <nav-buttons
      :style="{ 'margin-top': isMobile ? '0px' : '20px' }"
      :disable-previus="subStep <= 1 && !isMobile"
      :disable-next="!canGoNext"
      :is-mobile="isMobile"
      :moeda="moeda"
      :sub-total="subTotal"
      @next="next"
      @previus="previus" />
  </div>

  <!-- Componente Mobile -->
  <div v-else>
    <div v-show="subStep == 1">
      <div class="input-header">
        <strong>Etapa 1 de {{ nRootSteps }} - Escolha a quantidade de pessoas</strong>
      </div>
      <div>
        <i v-if="options.length <= 0">Nenhuma classificação disponível</i>
      </div>
      <div
        v-for="(option, i) in options"
        :key="option.id"
        :style="{ 'border-bottom': i >= options.length - 1 ? '1px solid #CCCCCC' : null }"
        class="faixa-mobile-option">
        <div class="faixa-mobile-option-info">
          <strong>{{ option.nome }}</strong>
          <br>
          <span>({{ option.descricao }})</span>
          <br>
        </div>
        <div
          class="faixa-mobile-option-quantity"
          translate="no">
          <i
            class="fa-solid fa-minus"
            style="cursor: pointer"
            @click="sub(option)" />
          <div class="faixa-mobile-option-quantity-display">
            <strong>{{ getCurrentQuantidade(option) }}</strong>
          </div>
          <i
            class="fa-solid fa-plus"
            style="cursor: pointer"
            @click="add(option)" />
        </div>
      </div>
      <div :style="{ visibility: isDependentOnly ? 'visible' : 'hidden' }">
        <small>É necessário adicionar ao menos 1 não dependente</small>
      </div>
      <div
        v-if="minVenda > 1 || maxVenda < Infinity"
        class="compliance-alert">
        <small v-if="minVenda > 1 && maxVenda < Infinity">
          O máximo de vagas para a compra desse combo por pessoa é: {{ maxVenda }} (caso tenha
          disponibilidade). E no mínimo {{ minVenda }}.
        </small>
        <small v-if="minVenda <= 1 && maxVenda < Infinity">
          O máximo de vagas para a compra desse combo por pessoa é: {{ maxVenda }} (caso tenha
          disponibilidade).
        </small>
        <small v-if="minVenda > 1 && maxVenda == Infinity">
          O mínimo de vagas para a compra desse combo por pessoa é: {{ minVenda }} (caso tenha
          disponibilidade).
        </small>
      </div>
    </div>

    <div v-show="subStep == 2">
      <div class="input-header">
        <strong>
          Etapa 2 de {{ nRootSteps }} - Escolha a data para as {{ nActivities }} atividades
        </strong>
      </div>
      <input-data-calendario
        v-if="onlySameDate"
        v-model="selectedDate"
        :passeio-id="comboId"
        :initial-available-days="initialAvailableDays"
        :calendar-size="calendarSizeParsed"
        :start-opened="true"
        :is-combo="true"
        @on-open-change="heightChange" />
    </div>

    <nav-buttons
      :style="{ 'margin-top': isMobile ? '0px' : '20px' }"
      :disable-previus="subStep <= 1 && !isMobile"
      :disable-next="!canGoNext"
      :is-mobile="isMobile"
      :moeda="moeda"
      :sub-total="subTotal"
      @next="next"
      @previus="previus" />
  </div>
</div>
</template>

<script>
import NavButtons from './NavButtons.vue';
import InputDataCalendario from '../components/InputDataCalendario.vue';

export default {
  components: { NavButtons, InputDataCalendario },
  props: {
    value: {
      type: Array,
      default: () => [],
      required: false
    },
    options: {
      type: Array,
      default: () => [],
      required: true
    },
    min: {
      type: String,
      default: () => '1',
      required: true
    },
    max: {
      type: String,
      default: () => '9999',
      required: true
    },
    isMobile: {
      type: Boolean,
      default: () => false,
      required: false
    },
    nomeItem: {
      type: String,
      default: () => 'PESSOAS',
      required: false
    },
    onlySameDate: {
      type: Boolean,
      default: () => false,
      required: true
    },
    calendarSize: {
      type: Number,
      default: () => 2,
      required: true
    },
    nRootSteps: {
      type: Number,
      default: () => 0,
      required: true
    },
    comboDate: {
      type: Date,
      default: () => null,
      required: false
    },
    comboId: {
      type: String,
      default: () => '0',
      required: false
    },
    initialAvailableDays: {
      type: String,
      default: () => '[]',
      required: false
    },
    moeda: {
      type: String,
      default: () => 'BRL',
      required: true
    },
    subTotal: {
      type: Number,
      default: () => 0,
      required: true
    },
    nActivities: {
      type: Number,
      default: () => 0,
      required: true
    }
  },
  emits: [
    'input',
    'on-complience-state-change',
    'next',
    'previus',
    'dom-height-change',
    'combo-date-selected'
  ],
  data() {
    return { subStep: 1 };
  },
  computed: {
    nSteps() {
      return this.onlySameDate ? 2 : 1;
    },
    canGoNext() {
      switch (this.subStep) {
      case 1:
        return this.somaQuantidade > 0;
      case 2:
        return this.selectedDate != null;
      default:
        return false;
      }
    },
    isDependentOnly() {
      if (!this.$props.value || this.$props.value.length <= 0) {
        return false;
      }
      for (let i = 0; i < this.$props.value.length; i++) {
        const faixa = this.$props.value[i];
        if (!faixa.dependente) {
          return false;
        }
      }
      return true;
    },
    respectMinMax() {
      if (!this.$props.value || this.$props.value.length <= 0) {
        return false;
      }
      return this.somaQuantidade >= this.minVenda && this.somaQuantidade <= this.maxVenda;
    },
    inCompliance() {
      return !this.isDependentOnly && this.respectMinMax;
    },
    minVenda() {
      const min = Number(this.$props.min);
      if (isNaN(min)) {
        return 1;
      }
      return min;
    },
    maxVenda() {
      const max = Number(this.$props.max);
      if (isNaN(max) || max < this.min) {
        return Infinity;
      }
      return max;
    },
    somaQuantidade() {
      let soma = 0;
      for (let i = 0; i < this.$props.value.length; i++) {
        const faixa = this.$props.value[i];
        soma += faixa.quantidade;
      }
      return soma;
    },
    selectedDate: {
      get() {
        return this.comboDate;
      },
      set(newValue) {
        this.$emit('combo-date-selected', newValue);
      }
    },
    calendarSizeParsed() {
      if (this.isMobile) {
        return 1;
      }
      return this.calendarSize;
    }
  },
  watch: {
    inCompliance() {
      this.$emit('on-complience-state-change', this.inCompliance);
    }
  },
  mounted() {
    this.$emit('on-complience-state-change', this.inCompliance);
  },
  methods: {
    sub(faixa) {
      this.mudarQuantidade(faixa, -1);
    },
    add(faixa) {
      this.mudarQuantidade(faixa, 1);
    },
    mudarQuantidade(faixa, quantidade) {
      const minLimit = 0;
      const vagasRestantes = this.maxVenda - this.somaQuantidade;
      if (quantidade > vagasRestantes) {
        return false;
      }

      const current = JSON.parse(JSON.stringify(this.$props.value));
      for (let i = 0; i < current.length; i++) {
        const faixaAtual = current[i];
        if (faixaAtual.id == faixa.id) {
          faixaAtual.quantidade += quantidade;
          if (faixaAtual.quantidade < minLimit) {
            return false;
          }
          this.$emit(
            'input',
            current.filter(faixa => faixa.quantidade > 0)
          );
          return true;
        }
      }
      if (quantidade < minLimit) {
        return false;
      }
      current.push({
        id: faixa.id,
        ordem: faixa.ordem,
        quantidade: quantidade,
        dependente: faixa.dependente == 1
      });
      current.sort((a, b) => Number(a.ordem) - Number(b.ordem));
      this.$emit(
        'input',
        current.filter(faixa => faixa.quantidade > 0)
      );
      return true;
    },
    getCurrentQuantidade(faixa) {
      for (let i = 0; i < this.$props.value.length; i++) {
        const faixaAdicionada = this.$props.value[i];
        if (faixaAdicionada.id == faixa.id) {
          return faixaAdicionada.quantidade;
        }
      }
      return 0;
    },
    getFaixaById(id) {
      for (let i = 0; i < this.options.length; i++) {
        const option = this.options[i];
        if (option.id == id) {
          return option;
        }
      }
      return null;
    },
    heightChange() {
      this.$nextTick(() => {
        this.$emit('dom-height-change');
      });
    },
    next() {
      if (this.subStep < this.nSteps) {
        this.subStep++;
        return;
      }
      this.$emit('next');
    },
    previus() {
      if (this.subStep > 1) {
        this.subStep--;
        return;
      }
      this.$emit('previus');
    }
  }
};
</script>

<style scoped>
.input-header {
  font-size: 14px;
  margin-top: 10px;
  margin-bottom: 20px;
}
.container-input .input-body {
  margin-top: 15px;
}

.faixa-option {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.faixa-option-info {
  line-height: 18px;
  font-size: 14px;
  width: 79%;
}
.faixa-option-quantity {
  width: 20%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.faixa-option-quantity-display {
  width: 40px;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  border: 1px solid #464646;
  color: #464646;
}

.faixa-mobile-option {
  padding-top: 20px;
  padding-bottom: 20px;
  border-top: 1px solid #cccccc;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-left: -30px;
  margin-right: -30px;
  padding-right: 30px;
  padding-left: 30px;
}

.faixa-mobile-option-info {
  line-height: 18px;
  font-size: 14px;
  width: 74%;
}
.faixa-mobile-option-quantity {
  width: 25%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.faixa-mobile-option-quantity-display {
  width: 40px;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  border: 1px solid #464646;
  color: #464646;
}

.compliance-alert {
  padding: 10px;
  border-radius: 12px;
  background-color: #f1f1f1;
}

@media (max-width: 770px) {
  .input-header {
    margin-left: -10px;
    width: calc(100% + 20px);
    padding-left: 10px;
  }
}
</style>
